import './Rex.scss';

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import cnames from 'classnames';

import * as PL from 'react-patterns';
import Accordion from '../../components/react-patterns/accordion/BasicAccordion';

const Button = PL.button.BasicButton;

const AlreadyHasProduct = () => (
  <div className="ea-notification ea-notification--tooltip ea-notification--error">
    <span className="ea-bodytext ea-notification__text">Asiakkaalla on jo ko. sopimus voimassaolevana. Lisätäksesi tämän edun, suljethan JPD:stä nykyisen sopimuksen.</span>
  </div>
);

class RexGift extends Component {
  static propTypes = {
    productId: PropTypes.number,
    name: PropTypes.string,
    description: PropTypes.string,
    priceDescription: PropTypes.string,
    freeDurationMonths: PropTypes.number,
    selectGift: PropTypes.any,
    isSelected: PropTypes.bool,
    userHasRelatedProduct: PropTypes.bool
  };

  selectGift = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.selectGift(this.props.productId);
  };

  render() {
    const btn = this.props.isSelected ?
      <Button icon="check" color="lightblue">Valittu</Button> :
      <Button color="light" onClick={this.selectGift}>Valitse</Button>;

    return (
      <div className="rx-gift">
        { this.props.userHasRelatedProduct && <AlreadyHasProduct/> }
        <div style={{padding: '20px'}}>
          <p>{this.props.description}</p>
          {this.props.freeDurationMonths !== 0 &&
          <div>
            <div className="rx-gift-duration">{this.props.freeDurationMonths} kk ajan</div>
            <div className="rx-gift-price">0 &euro; / kk</div>
          </div>
          }
          <p className="ea-disclaimertext rx-disclaimer">{this.props.priceDescription}</p>
          {btn}
        </div>
      </div>
    );
  }
}

class RexGiftChooser extends Component {
  static defaultProps = {
    type: 'public',
    title: 'Valitse lahjasi',
    gifts: []
  };

  static propTypes = {
    type: PropTypes.string,
    title: PropTypes.string,
    gifts: PropTypes.array,
    updateForm: PropTypes.any,
    selectedGift: PropTypes.any
  };

  confirm = (productId) => {
    this.props.updateForm({ selectedGift: productId });
  };

  render() {
    const { title, gifts, selectedGift } = this.props;
    let classNames = cnames('rx-chooser',
      { 'rx-type-undercounter': this.props.type === 'undercounter'});

    return (
      <div className={classNames}>
        <h3 className="ea-h3">{title}</h3>
        <Accordion isTight={true} className="rx-accordion">
          {
            gifts.map((item, i) =>
              (<div id={'gift' + i}
                    key={i}
                    header={
                      <div className={cnames('rx-gift-header', { 'rx-gift-selected': selectedGift === item.productId })}>
                        <span className="ea-icon ea-icon--check"></span>
                        <h4 className='ea-h4'>{item.name}</h4>
                      </div>
                    }>
                <RexGift {...item} isSelected={item.productId === selectedGift} selectGift={this.confirm}/>
              </div>))
          }
        </Accordion>
      </div>
    );
  }
}

export default RexGiftChooser;



// WEBPACK FOOTER //
// ./web/js/components/rex/GiftChooser.js